export default class UserPayloadV2 {
  constructor(
    public email: string,
    public password: string,
    public challenge?: boolean
  ) {}
}
